import React, { useState } from 'react';
import classnames from 'classnames';
import { Icon, Input } from 'components-guide';
import { handleSearch } from 'utils/header.utils';

import './NavSearchDesktop.scss';

export interface NavSearchDesktopProps {
    /**
     *  Invert
     */
    invert?: boolean;
    /**
     * Translate prop
     */
    t: any;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on click button
     */
    onClick?(): any;
}

const NavSearchDesktop: React.FC<NavSearchDesktopProps> = ({
    invert = false,
    t,
    className,
    style = {},
    onClick = () => {},
    ...props
}) => {
    const [showInput, setShowInput] = useState(false);
    const classNames = classnames(['nav-search-desktop', { invert }, className]);

    const handleToggleSearch = () => {
        setShowInput(!showInput);
        onClick();
    };

    return (
        <div className={classNames} style={style} {...props}>
            {showInput ? (
                <div className="nav-search-desktop__wrapper">
                    <Input
                        id="search"
                        name="search"
                        iconRight="search"
                        className="nav-search-desktop__input"
                        iconColor={invert ? 'white' : ''}
                        onKeyPress={handleSearch}
                        autoFocus
                    />
                    <Icon
                        name="x"
                        size={20}
                        color={invert ? 'white' : ''}
                        className="nav-search-desktop__icon"
                        onClick={handleToggleSearch}
                    />
                </div>
            ) : (
                <Icon
                    name="search"
                    size={20}
                    color={invert ? 'white' : ''}
                    className="nav-search-desktop__icon"
                    onClick={handleToggleSearch}
                />
            )}
        </div>
    );
};

export default NavSearchDesktop;
